import { lazy, FC, Suspense } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../_metronic/helpers'

const RepresentativeRoutes = () => {
  const SalesPage = lazy(() => import('../modules/representative/sales/SalesPage'))
  const PartnersPage = lazy(() => import('../modules/representative/partner/PartnersPage'))
  const InstallmentPackagesPage = lazy(() => import('../modules/representative/installment-package/InstallmentPackagesPage'))
  const IncomePage = lazy(() => import('../modules/representative/income/IncomePage'))
  const ManageClientPage = lazy(() => import('../modules/representative/manage-client/ManageClientPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route path='auth/*' element={<Navigate to='/sales' />} />
        <Route
          path='sales/*'
          element={
            <SuspensedView>
              <SalesPage />
            </SuspensedView>
          }
        />
        <Route
          path='partners/*'
          element={
            <SuspensedView>
              <PartnersPage />
            </SuspensedView>
          }
        />
        <Route
          path='manage-client/*'
          element={
            <SuspensedView>
              <ManageClientPage />
            </SuspensedView>
          }
        />
        <Route
          path='income/*'
          element={
            <SuspensedView>
              <IncomePage />
            </SuspensedView>
          }
        />
        <Route
          path='installment-package/*'
          element={
            <SuspensedView>
              <InstallmentPackagesPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { RepresentativeRoutes }
